import { Card } from '@mantine/core';
import classnames from 'classnames';
import classes from './CardPlay2.module.css';
import { By, Header, Id, Image, Title, Wrapper } from './CardPlay2.style';

export type CardPlay2Props = {
  level: 'gold' | 'silver' | 'bronze';
  tags?: string[];
  model: Json;
  onClick: () => void;
  small?: boolean;
};

export function CardPlay2(props: CardPlay2Props) {
  const { model, small } = props;
  const { id, name, meta, imageUrl, white } = model;

  const className = classnames('CardPlay2-wrapper', 'cyan-card', {
    small,
    white,
  });

  const style = {
    backgroundImage: `url(${imageUrl})`,
  };

  return (
    <Wrapper className={className} data-testid='CardPlay2-wrapper' onClick={props.onClick}>
      <Card withBorder radius='md' className={classes.card}>
        <Header>
          <Id>{id}</Id>
          <Title className='title'>{name}</Title>
          <By>by Sergio</By>
        </Header>
        <Image style={style} className='image' />
      </Card>
    </Wrapper>
  );
}

export default CardPlay2;
